var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10V8H7.5V10H0.5ZM0.5 6V4H11.5V6H0.5ZM0.5 2V0H11.5V2H0.5ZM9.5 16V12.925L15.025 7.425C15.175 7.275 15.3417 7.16667 15.525 7.1C15.7083 7.03333 15.8917 7 16.075 7C16.275 7 16.4667 7.0375 16.65 7.1125C16.8333 7.1875 17 7.3 17.15 7.45L18.075 8.375C18.2083 8.525 18.3125 8.69167 18.3875 8.875C18.4625 9.05833 18.5 9.24167 18.5 9.425C18.5 9.60833 18.4667 9.79583 18.4 9.9875C18.3333 10.1792 18.225 10.35 18.075 10.5L12.575 16H9.5ZM11 14.5H11.95L14.975 11.45L14.525 10.975L14.05 10.525L11 13.55V14.5ZM14.525 10.975L14.05 10.525L14.975 11.45L14.525 10.975Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNote);
export default __webpack_public_path__ + "static/media/Edit_note.3fcc2cddd613867838dd5e1c6d2f10c7.svg";
export { ForwardRef as ReactComponent };